import { render } from "./basedatetime.vue?vue&type=template&id=571faa96&scoped=true"
import script from "./basedatetime.vue?vue&type=script&lang=js"
export * from "./basedatetime.vue?vue&type=script&lang=js"

import "./basedatetime.vue?vue&type=style&index=0&id=571faa96&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-571faa96"]])

export default __exports__